import { Button } from '@/components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
} from '@/components/ModalSheet'

export interface ConflictDialogProps {
  showing: boolean
  lastUpdatedByName: string
  isForcePending: boolean
  isKeepPending: boolean
  onForce: () => unknown
  onKeep: () => unknown
  testId?: string
}

/**
 * Asks whether to force our changes or keep the ones someone else saved.
 */
export function ConflictDialog({
  showing,
  lastUpdatedByName,
  isForcePending,
  isKeepPending,
  onForce,
  onKeep,
  testId,
}: ConflictDialogProps) {
  const isPending = isForcePending || isKeepPending
  return (
    <ModalSheet
      showing={showing}
      disableCloseOnOutsideClick
      disableCloseOnEsc
      testId={testId}
    >
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            Looks like there's a conflict
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            <strong>{lastUpdatedByName || 'Someone'}</strong> has updated the
            legend since you last loaded it. Do you want to{' '}
            <strong>force your changes</strong>, or <strong>keep theirs</strong>
            ?
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Force my changes"
            variant="destructive"
            isPending={isForcePending}
            isDisabled={isPending}
            onPress={onForce}
            testId={testId && `${testId}-force`}
          />
          <Button
            label="Keep their changes"
            variant="primary"
            isPending={isKeepPending}
            isDisabled={isPending}
            onPress={onKeep}
            testId={testId && `${testId}-keep`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
